import { render, staticRenderFns } from "./survey-questionnaire-details.vue?vue&type=template&id=4f406512&scoped=true&"
import script from "./survey-questionnaire-details.vue?vue&type=script&lang=js&"
export * from "./survey-questionnaire-details.vue?vue&type=script&lang=js&"
import style0 from "./survey-questionnaire-details.vue?vue&type=style&index=0&id=4f406512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f406512",
  null
  
)

export default component.exports